var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSchedule20X20 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock_2_",
    "data-name": "clock (2)",
    transform: "translate(-1.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26617",
    "data-name": "Group 26617",
    transform: "translate(1.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26616",
    "data-name": "Group 26616",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46832",
    "data-name": "Path 46832",
    d: "M7.373,1.519,6.088,0l-4.6,3.828L2.778,5.348Z",
    transform: "translate(-1.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46833",
    "data-name": "Path 46833",
    d: "M308.6,3.935l-4.6-3.828L302.72,1.626l4.6,3.828Z",
    transform: "translate(-288.6 -.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46834",
    "data-name": "Path 46834",
    d: "M31.822,45.653a8.938,8.938,0,1,0,9,8.937A8.962,8.962,0,0,0,31.822,45.653Zm.005,15.889a6.952,6.952,0,1,1,7-6.951A6.977,6.977,0,0,1,31.827,61.542Z",
    transform: "translate(-21.827 -43.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46835",
    "data-name": "Path 46835",
    d: "M194.993,130.987h-1.5v5.958l4.745,2.835.755-1.226-4-2.354Z",
    transform: "translate(-184.493 -124.89)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSchedule20X20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_schedule20x20.6c4cbc15353fb3272a87a2c22e3bff09.svg";